export const routeConfig = {
  meta: {
    title: '融资详情',
  },
  params: ':financeOrderApplyId',
};
